// Central API configuration.
// The base URL comes from VITE_API_URL at build time and falls back to the
// production API host so a plain `vite build` is always deployment-ready.
export const API_BASE_URL: string = (
  import.meta.env.VITE_API_URL || 'https://api.nora.org.af'
).replace(/\/+$/, '');

// Build an absolute URL for an API/asset path.
// Pass-through for values that are already absolute (http/https or data URIs).
export const apiUrl = (path: string): string => {
  if (!path) return API_BASE_URL;
  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:')) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};
